import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { CategoriaArquivoService } from '../../../shared/services/apis/integracao-arquivos/categoria-arquivo.service';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { ListaCategoriaArquivoResponse } from '../../../shared/services/responses/integracao-arquivos/lista-categoria-arquivo.response';
import { CategoriaArquivo } from '../../../shared/services/models/integracao-arquivos/categoria-arquivo.model';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';

@Component({
  selector: 'app-categoria-arquivo-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    TemPermissaoDirective,
  ],
  templateUrl: './categoria-arquivo-lista.component.html',
  styleUrl: './categoria-arquivo-lista.component.css',
})
export class CategoriaArquivoListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private CategoriaArquivoService: CategoriaArquivoService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Desenvolvedor;
    this.funcionalidadeEnum = FuncionalidadeEnum.Desenvolvedor_CategoriaArquivo;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaCategoriaArquivoResponse: ListaCategoriaArquivoResponse | undefined;
  public displayedColumns: string[] = [
    'idCategoriaArquivo',
    'nome',
    'observacao',
    'action-edit',
    'action-delete',
  ];
  public _dataSource = new MatTableDataSource<CategoriaArquivo>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      nomePesquisa: [''],
    });

    this.pesquisar();
  }

  async pesquisar(): Promise<void> {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;

    const nome = this.model.get('nomePesquisa')?.value || null;

    this.CategoriaArquivoService.obterListaCategoriaArquivo(nome, this._paginaAtual).subscribe({
      next: (listaCategoriaArquivoResponse: ListaCategoriaArquivoResponse) => {
        if (listaCategoriaArquivoResponse.isError) {
          this.alertService.show('Erro', listaCategoriaArquivoResponse.errorDescription, AlertType.error);
          return;
        }

        this._isLoading = false;
        this._ultimaPagina = true;

        if (!this._listaCategoriaArquivoResponse) {
          this._listaCategoriaArquivoResponse = listaCategoriaArquivoResponse;
          this._ultimaPagina = false;
        }

        this._dataSource.data = this._listaCategoriaArquivoResponse.listaCategoriaArquivo;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaCategoriaArquivoResponse = undefined;
    this.pesquisar();
  }

  abrirModalExcluir(idCategoriaArquivo: number, nomeCategoria: string): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      data: {
        title: 'Alerta',
        description: `Deseja excluir a categoria ${nomeCategoria}? Essa ação será irreversível.`,
        buttonConfirm: 'Confirmar',
        buttonClose: 'Cancelar',
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.confirm) {
          this.excluir(idCategoriaArquivo);
        }
      },
    });
  }

  private excluir(idCategoriaArquivo: number): void {
    this.CategoriaArquivoService.excluir(idCategoriaArquivo).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.clickPesquisar();

        this.alertService.show('Sucesso', 'Categoria excluida com sucesso', AlertType.success);
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }
}
